import React from 'react'
import { isEmpty } from 'lodash'
import { Redirect } from 'react-router-dom'
import Snackbar from 'material-ui-legacy/Snackbar'
import ActionCompareArrows from 'material-ui-legacy/svg-icons/action/compare-arrows'
import ActionCheckCircle from 'material-ui-legacy/svg-icons/action/check-circle'
import { deepOrange500, lightGreenA700 } from 'material-ui-legacy/styles/colors'

import errors from '../../lib/errors.js'
import ErrorDialog from '../UI/ErrorDialog'
import ServiceForm from './ServiceForm'

import Resource from '../../stores/resource'
const ServiceStore = Resource('services')

class EditService extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      service: this.props.service || {},
      changed: false,
      saved: false,
      error: '',
      snackbarMessage: ''
    }
  }

  _save = attributes => {
    // Adjust attributes
    delete attributes.serviceCategoryName
    delete attributes.serviceCategoryFormattedName
    delete attributes.costFormulaName
    delete attributes.rateFormulaName
    // Update!
    ServiceStore.update(this.state.service.id, attributes)
      .then(result => {
        this.setState({
          saved: true,
          changed: false,
          error: '',
          result: result,
          snackbarMessage: `Service "${attributes.name}" saved!`
        })
      })
      .catch(error => {
        this.setState({
          saved: false,
          error: errors.unpack(error)
        })
      })
  }

  _changed = didChange => this.setState({ changed: didChange, saved: false })

  _closeErrorDialog = () => this.setState({ error: '' })

  _resetSnackbar = () => this.setState({ snackbarMessage: '' })

  _redirectTo = url => this.setState({ redirect: url })

  render() {
    if (this.state.redirect) return <Redirect push to={this.state.redirect} />

    const service = isEmpty(this.state.service) ? null : this.state.service

    const changed = this.state.changed
    const saved = this.state.saved

    return (
      <section>
        <ServiceForm
          formTitle={
            <span>
              {service.attributes.name}&nbsp;
              {changed && <ActionCompareArrows color={deepOrange500} />}
              {saved && <ActionCheckCircle color={lightGreenA700} />}
            </span>
          }
          service={service}
          changedCallback={this._changed}
          submitCallback={this._save}
          cancelCallback={() => this._redirectTo('/services')}
        />

        <Snackbar
          open={Boolean(this.state.snackbarMessage)}
          message={this.state.snackbarMessage}
          autoHideDuration={4000}
          onRequestClose={this._resetSnackbar}
        />

        <ErrorDialog
          open={Boolean(this.state.error)}
          closeCallback={this._closeErrorDialog}
          title="Couldn't save your changes"
        >
          <p>
            The service <strong>{service.attributes.fullName}</strong> remains
            unchanged.
          </p>
          <p>
            <strong>Error:</strong> {this.state.error}
          </p>
        </ErrorDialog>
      </section>
    )
  }
}

export default EditService



// WEBPACK FOOTER //
// ./src/components/Services/EditService.jsx